module.exports = __webpack_public_path__ + "img/dovx_eosvaultfort.b3572ad.png";